import { ref } from 'vue';
import PostSaleCasesAPI from 'dashboard/api/postSaleCases';

const messageFrom = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

const openExternalUrl = url =>
  window.open(url, '_blank', 'noopener,noreferrer');

export function usePostSaleExternalAction({
  t,
  notify,
  openUrl = openExternalUrl,
}) {
  const loading = ref(false);

  const request = async ({ postSaleCase, action }) => {
    loading.value = true;
    try {
      const { data } = await PostSaleCasesAPI.externalAction(postSaleCase.id, {
        action_code: action.code,
      });

      if (data?.status === 'configured' && data.url) {
        openUrl(data.url);
        return true;
      }

      notify(t('POST_SALE.AGENDA.ALERTS.ITBI_NOT_CONFIGURED'));
      return false;
    } catch (error) {
      notify(
        messageFrom(error, t('POST_SALE.AGENDA.ALERTS.EXTERNAL_ACTION_ERROR'))
      );
      return false;
    } finally {
      loading.value = false;
    }
  };

  return { loading, request };
}
